import { render, staticRenderFns } from "./RepairTypeCreate.vue?vue&type=template&id=07a8833e"
import script from "./RepairTypeCreate.vue?vue&type=script&lang=js"
export * from "./RepairTypeCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports